<template>
    <div class="landing-page">
        <a class="link" href="hap://app/yinghe.34bf34.wsss.minigame">
            <div class="img" :style="isMobile()">
                <div class="mask"></div>
            </div>
        </a>
        <div class="product">
            <div>产品名称：我是射手</div>
            <div>版本：1.0.37<router-link :to="{ path: '/Privacy' }" target="_blank">隐私协议</router-link></div>
        </div>
        <div class="copyright">
            <span><a href="https://beian.miit.gov.cn/">闽ICP备17013745号</a> COPYRIGHT ©2017 – 2020 风领科技. ALL RIGHTS RESERVED</span>
            <span>厦门风领科技有限公司 版权所有</span>
        </div>
    </div>
</template>
<script>
export default {
    data() {},
    methods: {
        isMobile() {
            const machineType = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop';
            if (machineType === 'Mobile') {
                return {
                    height: '636px',
                    width: '331.544px',
                };
            } else {
                return {
                    height: '949px',
                    width: '494.71px',
                };
            }
        },
    },
};
</script>
<style>
.landing-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.landing-page .link {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.landing-page .img {
    background-image: url(../common/imgs/game.png);
    height: 949px;
    width: 494.71px;
    align-self: center;
    border-radius: 70.6729px;
    user-select: none;
    background-size: 100%;
    background-repeat: round;
    box-shadow: 5px 5px 5px #999999;
}

.landing-page .mask {
    height: 100%;
    width: 100%;
    background-image: url(../common/imgs/mask.png);
    user-select: none;
    background-size: 100%;
    background-repeat: no-repeat;
}
.landing-page .product {
    margin-top: 20px;
    font-size: 12px;
}
.landing-page .product a {
    margin-left: 20px;
}
.landing-page .copyright {
    width: 375px;
}
.landing-page .copyright span {
    font-size: 12px;
    display: inline;
}
.landing-page .copyright span:last-child {
    margin-left: 10px;
}
</style>